const KENT = new Set([19901, 19902, 19903, 19904, 19905, 19906, 19934, 19936, 19938, 19943, 19946, 19952, 19953, 19954, 19955, 19961, 19962, 19963, 19964, 19977, 19979, 19980]);
const SUSSEX = new Set([19930, 19931, 19933, 19939, 19940, 19941, 19944, 19945, 19947, 19950, 19951, 19956, 19958, 19960, 19966, 19967, 19968, 19969, 19970, 19971, 19973, 19975]);

/** Delaware county for a ZIP, or "" when unknown / out of state. */
export function countyFromZip(zip, state = "") {
  const m = /^\s*(\d{5})/.exec(zip || "");
  if (!m) return "";
  const st = (state || "").trim().toUpperCase();
  if (st && st !== "DE" && st !== "DELAWARE") return "";
  const z = Number(m[1]);
  if (KENT.has(z)) return "Kent";
  if (SUSSEX.has(z)) return "Sussex";
  if (z >= 19701 && z <= 19899) return "New Castle";
  return "";
}
